namespace GeniuzPOS.Common.Helpers {
    export interface ExportExcelListRequest extends Serenity.ListRequest {
        ReportTitle?: string;
        WithExportedDate?: boolean;
        WithExportedUser?: boolean;
        FilteredDescriptions?: string[];
    }
}
